import { render } from "./Imports.vue?vue&type=template&id=4374ef30&ts=true"
import script from "./Imports.vue?vue&type=script&lang=ts"
export * from "./Imports.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__